import { Stack } from 'expo-router';

import HandleRedirectFromAuthorization from '../../auth/components/middleware/HandleRedirectFromAuthorization';
import HandleRedirectFromStorage from '../../auth/components/middleware/HandleRedirectFromStorage';
import RedirectIfNotAuthenticated from '../../auth/components/middleware/RedirectIfNotAuthenticated';
import { PremiumWelcomeSheet } from '../../billing/components/PremiumWelcomeSheet';
import { AuthedUserProvider } from '../../common/providers/AuthedUserProvider';
import { BankingExperienceProvider } from '../../common/providers/BankingExperienceProvider';
import Screens, { ModalScreens } from '../../common/types/Screens';
import FeatureFlagsProvider from '../../feature-flags/providers/FeatureFlagsProvider';
import { GuideDetailsModal } from '../../guidance/components/GuideDetailsModal';
import GuideMessagingProvider from '../../guideMessaging/providers/GuideMessagingProvider';
import { AboutInstitutionLinkingModal } from '../../holistic/components/AboutInstitutionLinking';
import QuilttConnectionStatusProvider from '../../holistic/providers/QuilttConnectionStatusProvider';
import QuilttSessionProvider from '../../holistic/providers/QuilttSessionProvider';
import HandleRedirectFromNotification from '../../notifications/components/HandleRedirectFromNotification';
import UpdateBadgeCount from '../../notifications/components/UpdateBadgeCount';
import InactivityDetector from '../../session/components/InactivityDetector';

// this is our app layout is used as an auth guard to redirect visitors to the auth flow
// since the auth routes sit outside (app), they are not subject to these redirect rules
export default function AppLayout() {
    return (
        <RedirectIfNotAuthenticated>
            <AuthedUserProvider>
                <QuilttSessionProvider>
                    <HandleRedirectFromAuthorization>
                        <HandleRedirectFromStorage>
                            <HandleRedirectFromNotification>
                                <FeatureFlagsProvider>
                                    <GuideMessagingProvider>
                                        <UpdateBadgeCount>
                                            <InactivityDetector>
                                                <BankingExperienceProvider>
                                                    <QuilttConnectionStatusProvider>
                                                        <Stack
                                                            screenOptions={{
                                                                headerShown: false,
                                                                contentStyle: {
                                                                    backgroundColor:
                                                                        'white',
                                                                },
                                                            }}
                                                        >
                                                            <Stack.Screen
                                                                name={
                                                                    Screens.Tabs
                                                                        .Home
                                                                }
                                                            />
                                                            <Stack.Screen
                                                                name={
                                                                    Screens
                                                                        .Onboarding
                                                                        .Biometrics
                                                                }
                                                                options={{
                                                                    animation:
                                                                        'slide_from_bottom',
                                                                }}
                                                            />
                                                            <Stack.Screen
                                                                name={
                                                                    Screens
                                                                        .Onboarding
                                                                        .Notifications
                                                                }
                                                                options={{
                                                                    animation:
                                                                        'fade',
                                                                }}
                                                            />
                                                            <Stack.Screen
                                                                name={
                                                                    ModalScreens.Goals_Explanation
                                                                }
                                                                options={{
                                                                    presentation:
                                                                        'modal',
                                                                    gestureEnabled: true,
                                                                    gestureDirection:
                                                                        'vertical',
                                                                }}
                                                            />
                                                            <Stack.Screen
                                                                name={
                                                                    ModalScreens.Bills_Details
                                                                }
                                                                options={{
                                                                    presentation:
                                                                        'modal',
                                                                    gestureEnabled: true,
                                                                    gestureDirection:
                                                                        'vertical',
                                                                }}
                                                            />
                                                            <Stack.Screen
                                                                name={
                                                                    ModalScreens.Bills_ManualBill
                                                                }
                                                                options={{
                                                                    presentation:
                                                                        'modal',
                                                                    gestureEnabled: true,
                                                                    gestureDirection:
                                                                        'vertical',
                                                                }}
                                                            />
                                                            <Stack.Screen
                                                                name={
                                                                    ModalScreens.Holistic_ConnectInstitution
                                                                }
                                                                options={{
                                                                    presentation:
                                                                        'modal',
                                                                    gestureEnabled: true,
                                                                    gestureDirection:
                                                                        'vertical',
                                                                }}
                                                            />
                                                            <Stack.Screen
                                                                name={
                                                                    ModalScreens.IncomeSplit_Edit
                                                                }
                                                                options={{
                                                                    presentation:
                                                                        'modal',
                                                                    gestureEnabled: true,
                                                                    gestureDirection:
                                                                        'vertical',
                                                                }}
                                                            />
                                                            <Stack.Screen
                                                                name={
                                                                    Screens
                                                                        .IncomeSplit
                                                                        .Index
                                                                }
                                                                options={{
                                                                    gestureEnabled: false,
                                                                }}
                                                            />
                                                            <Stack.Screen
                                                                name={
                                                                    ModalScreens.Holistic_EditInstitutionAccount
                                                                }
                                                                options={{
                                                                    presentation:
                                                                        'modal',
                                                                    gestureEnabled: true,
                                                                    gestureDirection:
                                                                        'vertical',
                                                                }}
                                                            />
                                                            <Stack.Screen
                                                                name={
                                                                    ModalScreens.Holistic_EditManualAccount
                                                                }
                                                                options={{
                                                                    presentation:
                                                                        'modal',
                                                                    gestureEnabled: true,
                                                                    gestureDirection:
                                                                        'vertical',
                                                                }}
                                                            />
                                                            <Stack.Screen
                                                                name={
                                                                    ModalScreens.Guidance_BookSession
                                                                }
                                                                options={{
                                                                    presentation:
                                                                        'modal',
                                                                    gestureEnabled: true,
                                                                    gestureDirection:
                                                                        'vertical',
                                                                }}
                                                            />
                                                            <Stack.Screen
                                                                name={
                                                                    ModalScreens.Guidance_CancelSession
                                                                }
                                                                options={{
                                                                    presentation:
                                                                        'modal',
                                                                    gestureEnabled: true,
                                                                    gestureDirection:
                                                                        'vertical',
                                                                }}
                                                            />
                                                            <Stack.Screen
                                                                name={
                                                                    ModalScreens.Guidance_RescheduleSession
                                                                }
                                                                options={{
                                                                    presentation:
                                                                        'modal',
                                                                    gestureEnabled: true,
                                                                    gestureDirection:
                                                                        'vertical',
                                                                }}
                                                            />
                                                        </Stack>
                                                        <AboutInstitutionLinkingModal />
                                                        <GuideDetailsModal />
                                                        <PremiumWelcomeSheet />
                                                    </QuilttConnectionStatusProvider>
                                                </BankingExperienceProvider>
                                            </InactivityDetector>
                                        </UpdateBadgeCount>
                                    </GuideMessagingProvider>
                                </FeatureFlagsProvider>
                            </HandleRedirectFromNotification>
                        </HandleRedirectFromStorage>
                    </HandleRedirectFromAuthorization>
                </QuilttSessionProvider>
            </AuthedUserProvider>
        </RedirectIfNotAuthenticated>
    );
}
